import './instrument';
import './preload-error-cache-busting';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app.tsx';
import { BrowserRouter } from 'react-router';
import './index.css';
import './i18n';
import './firebase';
import Modal from 'react-modal';

Modal.setAppElement('#root');

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </React.StrictMode>
);
